<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" scrollable max-width="700px" :fullscreen="$vuetify.breakpoint.xsOnly" @click:outside="close()">
      <v-card class="d-flex flex-column" :style="$vuetify.breakpoint.xsOnly ? 'height: 100%' : 'max-height: 100%'">
        <v-toolbar color="red darken-3" dark flat class="flex-shrink-0 flex-grow-0">
          <v-toolbar-title>CVEs</v-toolbar-title>

          <v-spacer />

          <v-chip v-if="!$vuetify.breakpoint.xsOnly" label style="font-family: monospace; font-weight: bold; word-spacing: -5px;" color="rgb(255,255,255,0.3)" class="white--text mr-2">{{ repository.split('/').join(' / ') }} @ {{ stage }}</v-chip>

          <v-chip label style="font-family: monospace; font-weight: bold; word-spacing: -5px;" color="rgb(255,255,255,0.3)" class="white--text mr-2"><v-icon left>view_in_ar</v-icon>{{ container }}</v-chip>

          <v-btn icon @click="info()"><v-icon>info_outline</v-icon></v-btn>

          <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pa-0" style="overflow-y: auto; flex: 1 1 auto; min-height: 0;">
          <div class="px-4 pt-3 pb-0">
            <v-switch v-model="onlyFixable" label="Somente com correção disponível" :disabled="fixable === 0" inset dense hide-details class="mt-0 pt-0 ml-1"></v-switch>
          </div>

          <div v-if="filtered.length === 0" class="text-center py-8 px-4 grey--text">
            Nenhum CVE com correção disponível neste serviço: os {{ cve.length }} restantes dependem de atualização do fornecedor da imagem ou do pacote.
          </div>

        <v-expansion-panels v-model="selected" class="px-4 py-4">
          <v-expansion-panel v-for="(item, i) in filtered" :key="item.id + '-' + i">
            <v-expansion-panel-header>
              <span style="font-family: monospace;" class="font-weight-bold">
                {{ item.id }}
              </span>
              <v-spacer />
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small class="mr-3 flex-grow-0" :color="hasFix(item) ? 'success' : 'grey lighten-1'">build</v-icon>
                </template>
                <span>{{ hasFix(item) ? 'Correção disponível: ' + item.fixed : 'Sem correção disponível' }}</span>
              </v-tooltip>
              <v-btn
                :color="item.severity === 'CRITICAL' ? 'error' : 'warning'"
                x-small
                elevation="0"
                readonly
                class="px-0 mr-2"
                max-width="80">
                {{ item.severity }}
              </v-btn>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pb-4">
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-list-item class="px-1 py-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-subtitle>Descrição:</v-list-item-subtitle>
                      <p class="my-0 pt-1">
                        {{ item.title }}
                      </p>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4" class="py-0">
                  <v-list-item class="px-1 py-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-subtitle>Pacote:</v-list-item-subtitle>
                      <v-list-item-title class="pt-1 font-weight-bold">
                        {{ item.package }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6" md="4" class="py-0">
                  <v-list-item class="px-1 py-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-subtitle>Versão Instalada:</v-list-item-subtitle>
                      <v-list-item-title class="pt-1 error--text font-weight-bold">
                        {{ item.installed }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6" md="4" class="py-0">
                  <v-list-item class="px-1 py-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-subtitle>Versão Corrigida:</v-list-item-subtitle>
                      <v-list-item-title v-if="hasFix(item)" class="pt-1 success--text font-weight-bold">
                        {{ item.fixed }}
                      </v-list-item-title>
                      <v-list-item-title v-else class="pt-1 grey--text font-italic">
                        sem correção disponível
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-list-item class="px-1 py-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-subtitle>Detalhes:</v-list-item-subtitle>
                      <p class="my-0 pt-1">
                        <a :href="'https://nvd.nist.gov/vuln/detail/' + item.id" target="_blank">
                          https://nvd.nist.gov/vuln/detail/{{ item.id }}
                        </a>
                      </p>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-card-text>

        <v-divider />
        <v-card-actions class="px-4 py-2 flex-wrap flex-shrink-0" style="background-color: #fafafa;">
          <div class="d-inline-flex my-1">
            <v-chip label small dark class="rounded-r-0" :color="critical > 0 ? 'error' : 'grey lighten-1'"><v-icon left small>report</v-icon>{{ critical }} CRITICAL</v-chip>
            <v-chip label small dark class="rounded-0" :color="high > 0 ? 'warning' : 'grey lighten-1'"><v-icon left small>warning</v-icon>{{ high }} HIGH</v-chip>
            <v-chip label small dark class="rounded-l-0" :color="fixable > 0 ? 'success' : 'grey lighten-1'"><v-icon left small>build</v-icon>{{ fixable }} com correção</v-chip>
          </div>
          <v-spacer />
          <span v-if="scanDate" class="body-2 grey--text text--darken-2 d-flex align-center my-1">
            <v-icon small class="mr-1">sync</v-icon>Verificado em <b class="ml-1">{{ scanDate }}</b>
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-wrapper ref="info" />
  </div>
</template>

<script>
import DialogWrapper from '@/components/DialogDefault.vue'

export default {
  components: {
    DialogWrapper
  },
  data () {
    return {
      dialog: false,
      selected: null,
      repository: '',
      stage: '',
      container: '',
      cve: [],
      date: '',
      onlyFixable: false
    }
  },
  computed: {
    critical () {
      return this.cve.filter(item => item.severity === 'CRITICAL').length
    },
    high () {
      return this.cve.filter(item => item.severity === 'HIGH').length
    },
    fixable () {
      return this.cve.filter(item => this.hasFix(item)).length
    },
    filtered () {
      const list = this.onlyFixable ? this.cve.filter(item => this.hasFix(item)) : this.cve.slice()

      // CRITICAL antes de HIGH; com correção disponível antes dos sem; depois o
      // identificador decrescente (CVE-AAAA-NNNN: os mais novos primeiro).
      const weight = item => (item.severity === 'CRITICAL' ? 0 : 1) * 2 + (this.hasFix(item) ? 0 : 1)

      return list.sort((a, b) => weight(a) - weight(b) || String(b.id).localeCompare(String(a.id), undefined, { numeric: true }))
    },
    scanDate () {
      // O automaton grava "j/n/y G:i" (hora sem zero à esquerda); aqui vira "14/10/26 00:08".
      if (!this.date) return ''

      const parts = this.date.trim().split(' ')

      if (parts.length !== 2) return this.date

      const time = parts[1].split(':')

      return parts[0] + ' ' + time.map(t => t.padStart(2, '0')).join(':')
    }
  },
  methods: {
    open (repository, stage, container, cve, date) {
      this.repository = repository
      this.stage = stage
      this.container = container

      this.cve = Array.isArray(cve) ? cve : []
      this.date = date || ''
      this.onlyFixable = false
      this.selected = null

      this.dialog = true
    },
    close () {
      this.dialog = false

      this.selected = null
    },
    hasFix (item) {
      return !!item.fixed && String(item.fixed).trim() !== ''
    },
    info () {
      this.$refs.info.open(null, '<p>As aplicações são escaneadas utilizando o <a href="https://trivy.dev" target="_blank">Trivy</a>, uma ferramenta de código aberto para análise de vulnerabilidades em contêineres.</p>' +
        '<p>O Trivy verifica as imagens em busca de vulnerabilidades conhecidas e fornece informações detalhadas sobre cada uma delas, incluindo a gravidade e a versão corrigida. Para mais informações, consulte a <a href="https://trivy.dev/latest/docs/" target="_blank">documentação da ferramenta</a>.</p>' +
        '<p>A varredura roda <strong>de hora em hora</strong> e só considera vulnerabilidades de gravidade <strong>HIGH</strong> e <strong>CRITICAL</strong>. A cada <em>deploy</em> a lista é apagada e refeita a partir das imagens novas: logo após implantar, a build fica como "aguardando varredura" até a próxima execução. O filtro "somente com correção disponível" mostra os CVEs que já têm versão corrigida do pacote; os demais dependem do fornecedor da imagem ou do pacote.</p>' +
        '<p>Para escanear localmente (com o Docker Compose) o serviço "<strong>' + this.container + '</strong>" em busca de CVEs, utilize o comando abaixo a partir do diretório da aplicação:</p>' +
        '<p class="text-left" style="font-family: monospace; font-weight: bold; word-spacing: -5px;">docker run --rm -v /var/run/docker.sock:/var/run/docker.sock aquasec/trivy image $(docker inspect $(docker compose ps -q ' + this.container + ') --format \'{{ .Config.Image }}\')</p>'
      )
    }
  }
}
</script>
